(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pricing_plan"] && !Shopify.designMode) return;
  try {
    

  
  // $(".swatches-select li").each(function(){
  //   var curr_escape = $(this).attr("data-escape");
  //   if(curr_escape == "Out of stock"){
  //     $(this).addClass("nt_soldout");
  //   }
  // });
  // $(document).on("click", ".swatches-select li", function(){
  //   $(".swatches-select li").removeClass("is-selected-nt");
  //   if(!$(this).hasClass("is-selected-nt")){
  //     $(this).addClass("is-selected-nt");
  //   }
  // })
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_tab"] && !Shopify.designMode) return;
  try {
    

  
  // $(".swatches-select li").each(function(){
  //   var curr_escape = $(this).attr("data-escape");
  //   if(curr_escape == "Out of stock"){
  //     $(this).addClass("nt_soldout");
  //   }
  // });
  // $(document).on("click", ".swatches-select li", function(){
  //   $(".swatches-select li").removeClass("is-selected-nt");
  //   if(!$(this).hasClass("is-selected-nt")){
  //     $(this).addClass("is-selected-nt");
  //   }
  // })
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_tab_BKP_22-07-24"] && !Shopify.designMode) return;
  try {
    

  
  // $(".swatches-select li").each(function(){
  //   var curr_escape = $(this).attr("data-escape");
  //   if(curr_escape == "Out of stock"){
  //     $(this).addClass("nt_soldout");
  //   }
  // });
  // $(document).on("click", ".swatches-select li", function(){
  //   $(".swatches-select li").removeClass("is-selected-nt");
  //   if(!$(this).hasClass("is-selected-nt")){
  //     $(this).addClass("is-selected-nt");
  //   }
  // })
  
  } catch(e) { console.error(e); }
})();
})();
